var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 6.66663L15 13.4V26.6L26.6667 33.3333L38.3333 26.6V13.4M26.6667 10.5166L33 14.1666L26.6667 17.8166L20.35 14.1666M0 11.6666V15H11.6667V11.6666M18.3333 16.85L25 20.7V28.5166L18.3333 24.6833M35 16.85V24.6833L28.3333 28.5166V20.7M3.33333 18.3333V21.6666H11.6667V18.3333M6.66667 25V28.3333H11.6667V25",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseWhite);
export default __webpack_public_path__ + "static/media/lease-white.4778edf33f99aa7f7108947227c8631b.svg";
export { ForwardRef as ReactComponent };